<template>
  <div>
    <div>
      <!-- Header Area -->
      <header class="main_header_area mha_2"></header>
      <!-- Header Area -->
      <vue-headful title="Credimóvil | Contrato Credito" :head="{
        'meta[charset]': { charset: 'utf-8' }
      }" />
      <!-- <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud> -->
      <menu-component></menu-component>
    </div>

    <section class="banner_area banner_area_8"></section>

    <!-- Banner Area -->
    <div class="container">
      <br>
      <div id="page1-div" ref="document" class="container interline">
        <div class="col-12 container border page-container">

          <div class="col-12 row row m-0 py-2">
            <div class="col-2 text-center p-2">
              <img src="../Contratos/Logo-GPI.png" class="rounded" width="65px" />
            </div>
            <div class="col-2 text-center p-2">
              <img src="../../../images/logo-splash-negro1.png" class="rounded" width="125px" />
            </div>
            <div class="col-8 text-center py-4">
              <div class="ft13Black">
                Cotizador Tradicional
              </div>
              <div class="ft11">
                GPI AUTO COMERCIAL SAPI DE C.V.
              </div>
              <div class="ft11">
                <div>
                  {{ fecha_cotizacion }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 row m-0 py-2 form-group row">
            <label for="inputPassword" class="col-sm-2 col-form-label">Dealer:</label>
            <div class="col-sm-8">
              <input id="inputDealer" ref="inputDealer" autocomplete="off" class="form-control ft12Black bg-gpi-azulito">
            </div>
          </div>
          <div class="col-12 row m-0 py-2 form-group row">
            <label for="inputPassword" class="col-sm-2 col-form-label">Asesor: </label>
            <div class="col-sm-8 ">
              <input id="inputDealer" ref="inputDealer" autocomplete="off" class="form-control ft12Black bg-gpi-azulito">
            </div>
          </div>

          <div class="col-12 row m-0 border border-dark py-2 form-group">
            <label for="inputPassword" class="col-sm-2 col-form-label">Cliente:</label>
            <div class="col-sm-8 m-0 p-0 border-bottom border-dark d-flex justify-content-center">
              <input id="inputDealer" ref="inputDealer" autocomplete="off" class="form-control ft12Black bg-gpi-azulito">
            </div>
          </div>

          <div class="col-12 m-0 p-1 d-flex justify-content-center">
            <span class="ft12Black align-self-end">Detalle del Vehículo </span>
          </div>
          <div class="col-12 row m-0 p-0 border border-dark">
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-sm-4 col-form-label">Marca:</label>
              <div class="col-sm-8 m-0 p-0 border-bottom border-dark d-flex justify-content-center">
                <input id="vehicle_brand" type="search" class="form-control ft12Black bg-gpi-azulito"
                  placeholder="Seleccione una marca" list="vehicle_brand_list" v-model="quote_credit.vehicle_brand"
                  autocomplete="off" :class="{
                    error:
                      $v.quote_credit.vehicle_brand.$dirty &&
                      $v.quote_credit.vehicle_brand.$invalid
                  }" required @blur="$v.quote_credit.vehicle_brand.$touch()" />
                <datalist id="vehicle_brand_list" :class="{ error: $v.quote_credit.vehicle_brand.$invalid }">
                  <option class="type_vehicle" value="Abarth">Abarth</option>
                  <option class="type_vehicle" value="Acura">Acura</option>
                  <option class="type_vehicle" value="Alfa Romeo">Alfa Romeo</option>
                  <option class="type_vehicle" value="Aston Martin">Aston Martin</option>
                  <option class="type_vehicle" value="Audi">Audi</option>
                  <option class="type_vehicle" value="BAIC">BAIC</option>
                  <option class="type_vehicle" value="Bentley">Bentley</option>
                  <option class="type_vehicle" value="BMW">BMW</option>
                  <option class="type_vehicle" value="Buick">Buick</option>
                  <option class="type_vehicle" value="Cadillac">Cadillac</option>
                  <option class="type_vehicle" value="Changan">Changan</option>
                  <option class="type_vehicle" value="Chery">Chery</option>
                  <option class="type_vehicle" value="Chevrolet">Chevrolet</option>
                  <option class="type_vehicle" value="Chrysler">Chrysler</option>
                  <option class="type_vehicle" value="Dodge">Dodge</option>
                  <option class="type_vehicle" value="DFSK">DFSK</option>
                  <option class="type_vehicle" value="FAW">FAW</option>
                  <option class="type_vehicle" value="Ferrari">Ferrari</option>
                  <option class="type_vehicle" value="Fiat">Fiat</option>
                  <option class="type_vehicle" value="Ford">Ford</option>
                  <option class="type_vehicle" value="GMC">GMC</option>
                  <option class="type_vehicle" value="Honda">Honda</option>
                  <option class="type_vehicle" value="Hyundai">Hyundai</option>
                  <option class="type_vehicle" value="Infiniti">Infiniti</option>
                  <option class="type_vehicle" value="Isuzu">Isuzu</option>
                  <option class="type_vehicle" value="JAC">JAC</option>
                  <option class="type_vehicle" value="Jaguar">Jaguar</option>
                  <option class="type_vehicle" value="Jeep">Jeep</option>
                  <option class="type_vehicle" value="Kia">Kia</option>
                  <option class="type_vehicle" value="Lamborghini">Lamborghini</option>
                  <option class="type_vehicle" value="Land Rover">Land Rover</option>
                  <option class="type_vehicle" value="Lexus">Lexus</option>
                  <option class="type_vehicle" value="Lincoln">Lincoln</option>
                  <option class="type_vehicle" value="Lotus">Lotus</option>
                  <option class="type_vehicle" value="Maserati">Maserati</option>
                  <option class="type_vehicle" value="Mazda">Mazda</option>
                  <option class="type_vehicle" value="McLaren">McLaren</option>
                  <option class="type_vehicle" value="Mercedes-Benz">Mercedes-Benz</option>
                  <option class="type_vehicle" value="MG">MG</option>
                  <option class="type_vehicle" value="MINI">MINI</option>
                  <option class="type_vehicle" value="Mitsubishi">Mitsubishi</option>
                  <option class="type_vehicle" value="Nissan">Nissan</option>
                  <option class="type_vehicle" value="Peugeot">Peugeot</option>
                  <option class="type_vehicle" value="Porsche">Porsche</option>
                  <option class="type_vehicle" value="Ram">Ram</option>
                  <option class="type_vehicle" value="Renault">Renault</option>
                  <option class="type_vehicle" value="Rolls Royce">Rolls Royce</option>
                  <option class="type_vehicle" value="SEAT">SEAT</option>
                  <option class="type_vehicle" value="Smart">Smart</option>
                  <option class="type_vehicle" value="SRT">SRT</option>
                  <option class="type_vehicle" value="Subaru">Subaru</option>
                  <option class="type_vehicle" value="Suzuki">Suzuki</option>
                  <option class="type_vehicle" value="Tesla">Tesla</option>
                  <option class="type_vehicle" value="Toyota">Toyota</option>
                  <option class="type_vehicle" value="Volkswagen">Volkswagen</option>
                  <option class="type_truck" disabled value="Dina">Dina</option>
                  <option class="type_truck" disabled value="Freightliner">Freightliner</option>
                  <option class="type_truck" disabled value="Hino">Hino</option>
                  <option class="type_truck" disabled value="International">International</option>
                  <option class="type_truck" disabled value="Isuzu">Isuzu</option>
                  <option class="type_truck" disabled value="Kenworth">Kenworth</option>
                  <option class="type_truck" disabled value="Mack">Mack</option>
                  <option class="type_truck" disabled value="MAN">MAN</option>
                  <option class="type_truck" disabled value="Mercedes-Benz">Mercedes-Benz</option>
                  <option class="type_truck" disabled value="Scania">Scania</option>
                  <option class="type_truck" disabled value="Volvo">Volvo</option>
                  <option class="type_truck" disabled value="VW">VW</option>
                  <option value="Otro">Otro</option>
                </datalist>
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-sm-4 col-form-label">Versión:</label>
              <div class="col-sm-8 m-0 p-0 border-bottom border-dark d-flex justify-content-center">
                <input id="inputDealer" ref="inputDealer" autocomplete="off" class="form-control ft12Black bg-gpi-azulito"
                  v-model="quote_credit.vehicle_model" :class="{
                    error:
                      $v.quote_credit.vehicle_model.$dirty &&
                      $v.quote_credit.vehicle_model.$invalid
                  }" required @blur="$v.quote_credit.vehicle_model.$touch()" />
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-sm-4 col-form-label">Año Modelo:</label>
              <div class="col-sm-8 m-0 p-0 border-bottom border-dark d-flex justify-content-center">
                <select class="form-control bg-gpi-azulito ft12Black" v-model="quote_credit.vehicle_version"
                  ref="vehicle_version" id="vehicle_version">
                  <option v-for="years in lastYears">{{ years }}</option>
                </select>
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-sm-4 col-form-label">Precio:</label>
              <div class="col-sm-8 m-0 p-0 border-bottom border-dark d-flex justify-content-center">
                <input id="inputVhiclePrice" v-on:change="onChangeAmount()" v-mask="numberMask"
                  v-model="masck.vehicle_price" type="text" ref="inputVhiclePrice" class="form-control bg-gpi-azulito"
                  @input="
                    quote_credit.vehicle_price = masck.vehicle_price.replace(/(?!-)[^0-9.]/g, '');
                  ">
              </div>
            </div>
          </div>

          <div class="col-12 m-0 p-1 d-flex justify-content-center">
            <span class="ft12Black align-self-end">Detalle de la Cotización</span>
          </div>
          <div class="col-12 row m-0 p-0 border border-dark">

            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-6 col-form-label">Enganche $:</label>
              <div class="col-sm-6 m-0 p-0 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <input id="inputVehicleHitch" v-on:change="onChangeAmount()" v-mask="numberMask"
                  v-model="masck.vehicle_hitch" type="text" ref="inputVehicleHitch" class="form-control bg-gpi-azulito"
                  @input="
                    quote_credit.vehicle_hitch = masck.vehicle_hitch.replace(/(?!-)[^0-9.]/g, '');
                  ">
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-6 col-form-label">Seguro de Contado:</label>
              <div class="col-sm-6 m-0 p-0 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <input id="inputCashInsurance" v-on:change="onChangeInsurce($event)" v-mask="numberMask"
                  v-model="masck.cash_insurance" type="text" ref="inputCashInsurance" class="form-control bg-gpi-azulito"
                  @input="
                    cash_insurance = masck.cash_insurance.replace(/(?!-)[^0-9.]/g, '');
                  ">
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-6 col-form-label">Enganche %:</label>
              <div class="col-sm-6 m-0 pl-1 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <span class="ft13Black align-self-center" :class="{ 'text-danger': vehicle_hitch_porcent < 20 }">
                  {{
                    getNumberLetter(vehicle_hitch_porcent) }}%</span>
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-6 col-form-label">Seguro Financiado:</label>
              <div class="col-sm-6 m-0 p-0 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <input id="inputFinancedInsurace" v-on:change="onChangeInsurce($event)" v-mask="numberMask"
                  v-model="masck.financed_insurance" type="text" ref="inputFinancedInsurace"
                  class="form-control bg-gpi-azulito" @input="
                    financed_insurance = masck.financed_insurance.replace(/(?!-)[^0-9.]/g, '');
                  ">
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-6 col-form-label">Comisión por Apertura:</label>
              <div class="col-sm-6 m-0 pl-1 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <span class="ft13Black align-self-center">{{ getNumberLetter(commission_opening) }}</span>
              </div>
            </div>
            <div class="col-6 row m-0 py-2 form-group">
              <label for="inputPassword" class="col-6 col-form-label">Monto a Financiar:</label>
              <div class="col-sm-6 m-0 pl-1 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <span class="ft13Black align-self-center">
                  {{ getNumberLetter(parseFloat(quote_credit.requested_amount_credit) +
                    parseFloat(financed_insurance))
                  }}</span>
              </div>
            </div>
            <div class="col-12 row m-0 py-2 form-group">
              <label for="inputPassword" class="offset-md-2 col-sm-3 col-form-label">Desembolso Inicial:</label>
              <div class="col-4 m-0 pl-1 border-bottom border-dark d-flex d-flex flex-row-reverse">
                <span class="ft13Black align-self-center">
                  {{ getNumberLetter(parseFloat(quote_credit.vehicle_hitch) +
                    parseFloat(cash_insurance) +
                    parseFloat(commission_opening)) }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 m-0 p-1 d-flex justify-content-center">
            <span class="ft12Black align-self-end">Tabla de Mensualidades</span>
          </div>
          <div class="col-12 row m-0 pt-2 border border-dark">
            <span class="col-12  ft12Black align-self-end">Marca el plazo deseado para solicitar el crédito</span>
            <div class="col-6 row m-0 py-2 form-group" :class="{ 'bg-gpi-azulito': quote_credit.months == 12 }">
              <label for="inputPassword" class="col-sm-4 col-form-label">12 meses:</label>
              <div class="col-sm-6 m-0 pl-1 border-bottom border-dark d-flex  flex-row-reverse">
                <span class="ft13Black align-self-center">{{ getNumberLetter(monthly_payment_12) }}</span>
              </div>
              <input id="check12" ref="check12" :checked="quote_credit.months == 12" @click="quote_credit.months = 12"
                type="checkbox" value="12">
            </div>
            <div class="col-6 row m-0 py-2 form-group" :class="{ 'bg-gpi-azulito': quote_credit.months == 24 }">
              <label for="inputPassword" class="col-sm-4 col-form-label">24 meses:</label>
              <div class="col-6 m-0 pl-1 border-bottom border-dark d-flex  flex-row-reverse">
                <span class="ft13Black align-self-center">{{ getNumberLetter(monthly_payment_24) }}</span>
              </div>
              <input id="check24" ref="check24" :checked="quote_credit.months == 24" @click="quote_credit.months = 24"
                type="checkbox" value="24">
            </div>
            <div class="col-6 row m-0 py-2 form-group" :class="{ 'bg-gpi-azulito': quote_credit.months == 36 }">
              <label for="inputPassword" class="col-sm-4 col-form-label">36 meses:</label>
              <div class="col-6 m-0 pl-1 border-bottom border-dark d-flex  flex-row-reverse">
                <span class="ft13Black align-self-center">{{ getNumberLetter(monthly_payment_36) }}</span>
              </div>
              <input id="check36" ref="check36" :checked="quote_credit.months == 36" @click="quote_credit.months = 36"
                type="checkbox" value="36">
            </div>
            <div class="col-6 row m-0 py-2 form-group" :class="{ 'bg-gpi-azulito': quote_credit.months == 48 }">
              <label for="inputPassword" class="col-sm-4 col-form-label">48 meses:</label>
              <div class="col-6 m-0 pl-1 border-bottom border-dark d-flex  flex-row-reverse">
                <span class="ft13Black align-self-center">{{ getNumberLetter(monthly_payment_48) }}</span>
              </div>
              <input id="check48" ref="check48" :checked="quote_credit.months == 48" @click="quote_credit.months = 48"
                type="checkbox" value="48">
            </div>
          </div>
          <div class="col-12 row pt-3">
            <span class="col-12 m-1 ft11">Cotización informativa, puede variar acorde al perfil del cliente.</span>
            <span class="col-12 m-1 ft11">Cotización sujeta a aprobación de crédito</span>
            <span class="col-12 m-1 ft11">La cotización incluye sistema de rastreo y seguro de vida deudor</span>
            <span class="col-12 m-1 ft11Black">Requisitos:</span>
            <span class="col-12 m-1 ft11">INE vigente</span>
            <span class="col-12 m-1 ft11">Comprobante de domiclio reciente</span>
            <span class="col-12 m-1 ft11">Ingresos de 3 meses nóminas con código QR o estados de cuenta bancarios con
              cadena fiscal y
              QR (totalidad de hojas)</span>
            <span class="col-12 m-1 ft11">3 referencias con teléfono fijo y celular</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center row p-3">
        <button type="button" @click="generatePDF()" class="btn btn-success col-3 m-1 ">
          Descargar PDF &nbsp; <span class="fa fa-download"> </span>
        </button>
        <button type="button" @click="saveQuotation()" class="btn btn-primary col-3 m-1"
          :disabled="vehicle_hitch_porcent < 20">
          Solicitar credito &nbsp; <span class="fa fa-check-square-o"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: true,
  allowNegative: false,
  requireDecimal: false,
  allowDecimal: true,
  decimalLimit: 2
});
import {
  required,
  minValue,
} from "vuelidate/lib/validators";
import Environments from "../../environments/Environment";
import html2pdf from "html2pdf.js";
let now = new Date();
var meses = new Array(
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
);
export default {
  name: "Cotizacion_Tradicional",
  data() {
    return {
      numberMask,
      TASA: Environments.TASA,
      GPS: Environments.GPS,
      SEGURODEUDOR: Environments.SEGURODEUDOR,
      comisionApertura: Environments.COMISION_APERTURA,
      comisionAsesor: Environments.COMISION_ASESOR,
      lastYears: [],
      vehicleBrand: [],
      vehicle_hitch_porcent: "0.0",
      commission_opening: "0.00",
      cash_insurance: "0.00",
      financed_insurance: "0.00",
      monthly_payment_12: "0.00",
      monthly_payment_24: "0.00",
      monthly_payment_36: "0.00",
      monthly_payment_48: "0.00",
      fecha_cotizacion:
        now.getDate() +
        " de " +
        meses[now.getMonth()] +
        " del " +
        now.getFullYear(),
      quote_credit: {
        user_id: "",
        vehicle_model: "",
        vehicle_brand: "",
        vehicle_version: "",
        vehicle_description: "",
        purpose_of_vehicle: "",
        vehicle_price: 0.0,
        vehicle_hitch: 0.0,
        requested_amount_credit: 0.0,
        vehicle_type: "",
        lote: "",
        months: 0,
        insurance_payment: ""
      },
      insurce: {
        insurce_price: 0.00
      },
      masck: {
        vehicle_price: 0,
        vehicle_hitch: 0,
        financed_insurance: 0,
        cash_insurance: 0
      }
    };
  },
  validations() {
    return {
      quote_credit: {
        vehicle_model: { required },
        vehicle_brand: { required },
        requested_amount_credit: { required },
        desired_payment: { required },
        vehicle_version: { required, minValue: minValue(2012), $lazy: true },
      }
    };
  },

  methods: {
    generatePDF() {
      this.preloader();
      const elements = document.querySelectorAll(".page-container");
      elements.forEach(element => {
        element.classList.remove("border");
      });

      html2pdf(this.$refs.document, {
        margin: 1,
        filename:
          "Cotizacion-" +
          ".pdf",
        image: { type: "jpeg", quality: 2 },
        html2canvas: {
          scale: 2,
          dpi: 600,
          letterRendering: true,
          allowTaint: true,
          useCORS: true,
          imageTimeout: 35000,
          logging: true
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "p", compress: true }
      }).then(result => {
        elements.forEach(element => {
          element.classList.add("border");
        });
        this.preloaderHiden();
      });
    },
    getQuotation() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.quote_credit.id = result.data[0].id;
            this.quote_credit.vehicle_price = result.data[0].vehicle_price;
            this.masck.vehicle_price = result.data[0].vehicle_price;
            this.quote_credit.vehicle_hitch = result.data[0].vehicle_hitch;
            this.masck.vehicle_hitch = result.data[0].vehicle_hitch;
            this.quote_credit.requested_amount_credit = result.data[0].requested_amount_credit;
            this.commission_opening = this.quote_credit.requested_amount_credit * (this.comisionApertura / 100);
            this.quote_credit.months = result.data[0].months;

            this.quote_credit.vehicle_model = result.data[0].vehicle_model;
            this.quote_credit.vehicle_brand = result.data[0].vehicle_brand;
            this.quote_credit.vehicle_version = result.data[0].vehicle_version;

            this.vehicle_hitch_porcent = parseFloat(this.quote_credit.vehicle_hitch * 100) / parseFloat(this.quote_credit.vehicle_price)

            if (this.quote_credit.insurance_payment == "CONTADO") {
              this.cash_insurance = this.insurce.insurce_price | 0;
              this.masck.cash_insurance = rthis.insurce.insurce_price | 0;
            } else {
              this.financed_insurance = this.insurce.insurce_price | 0;
              this.masck.financed_insurance = this.insurce.insurce_price | 0;
            }
          }
          //this.preloaderHiden();
        },
        err => {
          this.preloaderHiden();
          this.$swal("CUIDADO!", err.msg, "error");
        }
      );
    },
    getInsurce() {
      this.$InsuranceService.getInsurce().then(
        result => {
          if (result.data.length > 0) {
            this.insurce.insurce_price = result.data[0].insurce_price;
          }
        },
        err => {
          console.log(err);
          this.preloaderHiden();
          this.$swal("CUIDADO!", err.msg, "error");
        }
      );
    },
    onChangeBrand() {
      this.quote_credit.vehicle_brand = $("#vehicle_brand").val();
      if (this.vehicleBrand.length == 0) {
        for (var option of document.getElementById("vehicle_brand_list")
          .options) {
          this.vehicleBrand.push(option.value);
        }
      }
      if (
        !this.datalistValidator(
          this.quote_credit.vehicle_brand,
          this.vehicleBrand
        )
      ) {
        $("#vehicle_brand").val("");
        this.quote_credit.vehicle_brand = "";
      }
    },
    onChangeAmount() {
      this.quote_credit.vehicle_hitch = parseFloat(this.quote_credit.vehicle_hitch.replace(/(?!-)[^0-9.]/g, ''));
      this.quote_credit.vehicle_price = parseFloat(this.quote_credit.vehicle_price.replace(/(?!-)[^0-9.]/g, ''));

      this.vehicle_hitch_porcent = (this.quote_credit.vehicle_hitch * 100) / (this.quote_credit.vehicle_price)
      this.quote_credit.requested_amount_credit = (this.quote_credit.vehicle_price) - (this.quote_credit.vehicle_hitch);
      this.commission_opening = this.quote_credit.requested_amount_credit * (this.comisionApertura / 100);
      setTimeout(() => {
        this.calculateMonthly();
        if (this.vehicle_hitch_porcent < 20) {
          this.$swal("", "Engache debe ser minimo 20%", "warning");
        }
      }, 500);
    },
    onChangeInsurce(event) {

      if (event.target.id == "inputCashInsurance") {
        this.financed_insurance = 0;
        this.masck.financed_insurance = 0;
      } else {
        this.cash_insurance = 0;
        this.masck.cash_insurance = 0;
      }

      this.insurce.insurce_price = event.target.value.replace(/(?!-)[^0-9.]/g, '');
      setTimeout(() => {
        this.onChangeAmount();
      }, 500);
    },
    getLastYears() {
      var year = new Date().getFullYear();
      for (let index = 0; index < 12; index++) {
        this.lastYears.push(year - index);
      }
    },
    getNumberLetter(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    datalistValidator(modelname, modelList) {
      var result = modelList.indexOf(modelname) > -1;
      if (!result) {
        this.$swal("Cuidado!", "Seleccione un elemento de la lista", "warning");
      }
      return result;
    },
    calculateMonthly() {

      this.quote_credit.vehicle_hitch = this.quote_credit.vehicle_hitch.replace(/(?!-)[^0-9.]/g, '');
      this.quote_credit.vehicle_price = this.quote_credit.vehicle_price.replace(/(?!-)[^0-9.]/g, '');
      this.monthly_payment_12 = parseFloat(
        (parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - parseFloat(this.quote_credit.vehicle_hitch)) /
        parseFloat(12) +
        (((parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - parseFloat(this.quote_credit.vehicle_hitch)) / 100) *
          parseFloat(this.TASA)) +
        parseFloat(this.GPS) +
        parseFloat(this.SEGURODEUDOR)
      );
      this.monthly_payment_24 = parseFloat(
        (parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - this.quote_credit.vehicle_hitch) /
        24 +
        ((parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - parseFloat(this.quote_credit.vehicle_hitch)) / 100) *
        this.TASA +
        this.GPS +
        this.SEGURODEUDOR
      );
      this.monthly_payment_36 = parseFloat(
        (parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - this.quote_credit.vehicle_hitch) /
        36 +
        ((parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - parseFloat(this.quote_credit.vehicle_hitch)) / 100) *
        this.TASA +
        this.GPS +
        this.SEGURODEUDOR
      );
      this.monthly_payment_48 = parseFloat(
        (parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - parseFloat(this.quote_credit.vehicle_hitch)) /
        48 +
        ((parseFloat(this.financed_insurance) + parseFloat(this.quote_credit.vehicle_price) - parseFloat(this.quote_credit.vehicle_hitch)) / 100) *
        this.TASA +
        this.GPS +
        this.SEGURODEUDOR
      );

    },
    saveQuotation() {
      if (this.$refs.check12.checked ||
        this.$refs.check24.checked ||
        this.$refs.check36.checked ||
        this.$refs.check48.checked) {
        this.quote_credit.user_id = localStorage.getItem("id");

        this.$UserService.createCreditQuotation({ data: this.quote_credit }).then(
          result => {
            localStorage.setItem('quote_credit', result.data.insertId);
            if (this.quote_credit.user_id != null) {
              this.preloaderHiden();
              console.log("--------approval-----");
              window.location = '/pre-approval';
            } else {
              this.preloaderHiden();
              console.log("--------create-----");
              window.location = '/create-account';
            }
          },
          err => {
            console.log("--------error-----");
            console.log(err.msg);
            //this.$swal(err.msg);
            this.preloaderHiden();
          }
        ).catch(error => {
          console.log("error - ", error);
        });
      } else {
        this.$swal("", "Es necesario seleccionar un plazo", "warning");
      }
    },
    start() {

      let data = JSON.parse(localStorage.getItem("quote_data"));
      if (data) {
        this.quote_credit.vehicle_price = data.vehicle_price;
        this.masck.vehicle_price = data.vehicle_price;
        this.quote_credit.vehicle_hitch = data.vehicle_hitch;
        this.masck.vehicle_hitch = data.vehicle_hitch;
        this.quote_credit.requested_amount_credit = data.requested_amount_credit;
        this.commission_opening = this.quote_credit.requested_amount_credit * (this.comisionApertura / 100);
        this.quote_credit.months = data.months;
        this.vehicle_hitch_porcent = (this.quote_credit.vehicle_hitch * 100) / this.quote_credit.vehicle_price

      } else {
        this.getInsurce();
        this.getQuotation();
        this.onChangeAmount();
      }
      setTimeout(() => {
        this.calculateMonthly();
      }, 1500);
      window.scrollTo(0, 200);

    },
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  mounted() {

  },
  created() {
    this.start();
    this.getLastYears();
  }
};
</script>
<style type="text/scss">
@import "../Contratos/style.scss";

.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/cotizacion/CotizacionTradicional.vue